<script setup lang="ts">
import Pdf from "@/components/Pdf.vue"
import { useMediaUrl } from "@/composables"

const props = defineProps<{
    element: any
}>()

const { mediaUrl } = useMediaUrl()
</script>

<template>
    <div class="ce-pdf">
        <pdf :file="mediaUrl(props.element.fileName)" :paginated="true"></pdf>
    </div>
</template>
